import { useTranslations } from '@vocab/react';
import React from 'react';

import { RefreshFlowDataContext } from 'src/app/views/context/cajaFlowData';
import { useAdvertiserId } from 'src/app/views/hooks/useAdvertiserId';
import { useCurrentUser } from 'src/app/views/hooks/useCurrentUser';
import { useDataCleanup } from 'src/app/views/hooks/useDataCleanup';
import { useFlowType } from 'src/app/views/hooks/useFlowType';
import { useHirerAccountAndContractBalance } from 'src/app/views/hooks/useHirerAccountAndContractBalance';
import { useIdentity } from 'src/app/views/hooks/useIdentity';
import { useJobData } from 'src/app/views/hooks/useJobData';
import { useJobId } from 'src/app/views/hooks/useJobId';
import { useTealiumEditOrRefreshFlowType } from 'src/app/views/hooks/useTealiumEditOrRefreshFlowType';
import { SeoTitle } from 'src/app/views/shared/SeoTitle';
import type { ContainerProps } from 'src/types/app';

import translations from '../.vocab';

// Initialise Refresh flow and render page component
const RefreshFlowContainer = ({ children }: ContainerProps) => {
  const { t } = useTranslations(translations);

  useDataCleanup();
  useFlowType('refresh');
  useTealiumEditOrRefreshFlowType('refresh');
  useAdvertiserId();
  useJobId();
  // Retrieve job details for tracking
  const { loading: isJobDataLoading } = useJobData();
  useHirerAccountAndContractBalance();
  useCurrentUser();
  useIdentity();

  return (
    <RefreshFlowDataContext.Provider
      value={{
        loading: isJobDataLoading,
      }}
    >
      <SeoTitle title={t('refresh-container-seo-title')} />
      {children}
    </RefreshFlowDataContext.Provider>
  );
};

export default RefreshFlowContainer;
